import { Commit } from 'vuex';
import Vue from 'vue';
import { OccupancyReport } from '@/interfaces/reports';

interface OccupancyState {
	occupancyReports: {
		[id: number]: OccupancyReport;
	};
}

export default {
	namespaced: true,
	state: {
		occupancyReports: {},
	} as OccupancyState,
	getters: {
		getOccupancyReports: (state: OccupancyState): { [id: number]: OccupancyReport } => {
			return state.occupancyReports;
		},
	},
	mutations: {
		SET_OCCUPANCY(
			state: OccupancyState,
			{
				occupancyReports,
				messageStatus,
			}: { occupancyReports: OccupancyReport[]; messageStatus: string }
		): void {
			const ret: { [id: number]: OccupancyReport } = {};
			const templates = occupancyReports.reduce((obj, report) => {
				report.message = messageStatus;
				obj[report.fk_zone_id] = report;
				return obj;
			}, ret);

			state.occupancyReports = {
				...state.occupancyReports,
				...templates,
			};
		},
		CLEAN_REPORTS(state: OccupancyState): void {
			state.occupancyReports = {};
		},
	},
	actions: {
		async fetchOccupancyReport(
			{ commit }: { commit: Commit },
			{ params }: { params: OccupancyReport }
		): Promise<void | OccupancyReport> {
			if (params.devices.length > 0) {
				const queryParams = new URLSearchParams();
				for (const devices of params.devices) {
					queryParams.append('devices', devices);
				}
				for (const zone of params.zones) {
					queryParams.append('zones', zone);
				}
				queryParams.append('start', params.start);
				queryParams.append('end', params.end);
				queryParams.append('start2', params.start2);
				queryParams.append('end2', params.end2);
				queryParams.append('useMap', 'False');

				const response = await Vue.axios.get(
					`${process.env.VUE_APP_API_URL}/lighting/reports/occupancy/`,
					{ params: queryParams }
				);
				if (response && response.status === 200) {
					for (const response_data of response.data.data) {
						commit('SET_OCCUPANCY', {
							occupancyReports: [response_data],
							messageStatus:
								response_data['device'].length === 0 ? 'No Devices in zone' : response.data.message,
						});
					}
				}
			} else {
				commit('SET_OCCUPANCY', {
					occupancyReports: [
						{
							fk_zone_id: params.zones[0],
							pct_outside_working_h_week_one: 0,
							pct_outside_working_h_week_two: 0,
							pct_working_h_week_one: 0,
							pct_working_h_week_two: 0,
						},
					],
					messageStatus: 'No Devices in the zone',
				});
			}
		},

		cleanAllReports({ commit }: { commit: Commit }): void {
			commit('CLEAN_REPORTS');
		},
	},
};
